(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay-lyckoplatsen/assets/javascripts/track-successful-wagers.js') >= 0) return;  svs.modules.push('/components/tur/pay-lyckoplatsen/assets/javascripts/track-successful-wagers.js');

'use strict';

const {
  transactionItem: AnalyticsTransactionItem,
  transaction: AnalyticsTransaction
} = svs.components.analytics;
const {
  Currency: formatCurrency
} = svs.utils.format;
function trackSuccessfulWagers(_ref) {
  let {
    next,
    successfulWagers
  } = _ref;
  next();
  successfulWagers.forEach(successfulWager => {
    const {
      wager,
      wagerAmounts,
      wagerClientSerial
    } = successfulWager;
    const options = {
      prolong: wager.isProlongination ? '1' : '0',
      geoLocType: wager.pinLocationType,
      geoLocName: svs.tur.lyckoplatsen.utils.isDefaultLocationName(wager.lyckoplatsenName) ? 'CTA_spela' : 'CTA_spelaName',
      reverseGeo: wager.pinLocationType === 'HOME' ? '' : wager.locationName,
      activeLoc: undefined,
      rounds: wager.numberOfWeeks
    };
    if (wager.isProlongination && wager.prolongOriginalWager) {
      options.retailCampaign = wager.prolongOriginalWager.totalDrawCount === 1 ? 'yes' : 'no';
    }
    const item = new AnalyticsTransactionItem('LYCKOPLATSEN', 'Lyckoplatsen', formatCurrency(wagerAmounts.totalAmount), 1, options);
    const transaction = new AnalyticsTransaction(wagerClientSerial, formatCurrency(wagerAmounts.totalAmount), [item], 0, 0, undefined, 'LYCKOPLATSEN');
    svs.components.analytics.trackTransaction(transaction);
  });
}
setGlobal('svs.tur.pay_lyckoplatsen', {
  trackSuccessfulWagers
});

 })(window);